import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
  Custom,
  AsociacionTareaForma,
  ModalSelect
} from '@app/shared';


@Injectable()
export class CheckListParametersFormsService {
  constructor() { }

  /**
   * Genera el formulario de agregar o modificar la asociacion
   *
   * @param {*} options
   * @param {*} [data]
   * @returns {BaseControl<any>[]}
   * @memberof CheckListParametersFormsService
   */
  getForm(options: any, data?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new ModalSelect({
        key: 'cboRegister',
        label: 'Registro:',
        value: data ? data['id'] ? data['id'] : null : null,
        order: 1,
        placeholder: 'Seleccione un registro de la modal',
        validations: {
          validators: [Validators.required]
        },
        data: options ? options['registros'] ? options['registros'] ? options['registros'] : [] : [] : [],
        columns: [
          {
            key: 'value',
            label: 'Registro'
          }
        ],
        keyValue: 'key',
        classModal: 'modal-lg-personalized',
        class: 'form-control',
        actionAdd: true,
        actionUpdate: true,
        actionDelete: true,
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/shared-administration/check-list-parameters/shared/check-list-parameters.form.service.ts